import {on} from "@/others/common/eventDelegation";

export function initAjaxVariantChanger(selector)
{
	on(".content-wrap", "click", selector, event => {
		const targetEl = event.target;

		$.nette.ajax({
			method: "GET",
			url: targetEl.dataset.changeUrl
		});
	});
}
